// components/ErrorBoundary.jsx
import React from "react";  
 import type { ReactNode, ErrorInfo } from "react";
interface ErrorBoundaryProps {
  children: ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
  error: Error | null;
}

class ErrorBoundary extends React.Component<
  ErrorBoundaryProps,
  ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error:Error) {
    return { hasError: true, error };
  }

  componentDidCatch(error:Error, errorInfo: ErrorInfo) {
    console.error("Error caught by ErrorBoundary:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ color: "red" }}>Error: {this.state.error?.message}</div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
